export const emptyFormTemplate = {
    id: "",
    title: {},
    errorMessages: {},
    elements: []
};
